<div id="sub-top">
    <div class="img-wrap">
        <img src="/assets/images/recruit.png">
        <h2 data-aos="fade-right" data-aos-duration="2000">
            <strong>아이로브는</strong> 협력하여 도전하는 <br> 진취적인 행보의 인재와 함께 하기를 고대합니다.
        </h2>
    </div>
</div>
<section [ngSwitch]='subPage'>
    <div class="sub-path">
        <ul >
            <li>인재채용 ></li>
            <li *ngSwitchCase="'talent'">인재상</li>
            <li *ngSwitchCase="'welfare'">복리후생</li>
            <li *ngSwitchCase="'recruitList'">채용알림</li>
            <li *ngSwitchDefault></li>
        </ul>
        <div class="tab">
            <ul>
                <li><a [ngClass]="{'on': subPage === 'talent'}" (click)="subPage='talent'" >인재상</a></li>
                <li><a [ngClass]="{'on': subPage === 'welfare'}"  (click)="subPage='welfare'" >복리후생</a></li>
                <li><a [ngClass]="{'on': subPage === 'recruitList'}" (click)="subPage='recruitList'" >채용알림</a></li>
            </ul>

            <!-- select bar -->
            <div *ngSwitchCase="'talent'" class="tab-indicator recruit-talent"></div>
            <div *ngSwitchCase="'welfare'" class="tab-indicator recruit-welfare"></div>
            <div *ngSwitchCase="'recruitList'" class="tab-indicator recruit-recruitList"></div>
            <div *ngSwitchDefault></div>
        </div>

    </div>

    <!-- sub page -->
        <article *ngSwitchCase="'talent'"><app-talent></app-talent></article>
        <article *ngSwitchCase="'welfare'"><app-welfare></app-welfare></article> 
        <article *ngSwitchCase="'recruitList'"><app-recruit-list></app-recruit-list></article> 
        <article *ngSwitchDefault></article>

</section>